import { NodeFormValues } from "@features/builder/NodeDrawer/NodeForm"
import { TableNodeHeader } from "@features/builder/NodeDrawer/NodeForm/NodeTableAccordion/types"
import { BaseGraphTableNode } from "@store/services/converter/types"
import { enqueueSnackbar } from "notistack"
import { UseFormReturn } from "react-hook-form"

export function getHeaders(
  properties: BaseGraphTableNode,
  form: UseFormReturn<NodeFormValues>,
  onPropertiesUpdate?: (properties: BaseGraphTableNode) => void,
) {
  const formDisabled = form.formState.disabled
  const color = ""

  let handleRemove: TableNodeHeader["onRemove"]

  if (!formDisabled) {
    handleRemove = (name) => {
      if (name === undefined) return

      if (properties.columns.length === 1) {
        enqueueSnackbar("You can not remove last column", { variant: "error" })
        return
      }

      const columnIndex = properties.columns.findIndex((columnName) => columnName === name)
      const updatedProperties = structuredClone(properties)
      updatedProperties.data.map((row) => row.splice(columnIndex, 1))
      updatedProperties.columns.splice(columnIndex, 1)
      onPropertiesUpdate?.(updatedProperties)
    }
  }

  const headers: TableNodeHeader[] = properties.columns.map((value, idx) => ({
    editable: !formDisabled,
    value: form.getValues(`attributeProperties.columns.${idx}`),
    color,
    name: `attributeProperties.columns.${idx}`,
    errorMessage: form.formState.errors.attributeProperties?.columns?.[idx]?.message ?? "",
    idx,
    key: `${idx}`,
    onBlur: (newValue) => {
      const newProperties = structuredClone(properties)
      newProperties.columns[idx] = newValue
      onPropertiesUpdate?.(newProperties)
    },
    onRemove: handleRemove,
  }))
  headers.unshift({ value: " ", color, key: "-1", idx: -1 })
  return headers
}
